export default "__VITE_ASSET__pRKkevCF__"